// Parse an toàn, tránh lệch ngày do UTC
function parseLocalDate(dateStr) {
  if (!dateStr) return null;
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    const [y, m, d] = dateStr.split("-").map(Number);
    return new Date(y, m - 1, d); // local time, không bị UTC offset
  }
  if (typeof dateStr === "string" && dateStr.includes("T")) {
    return new Date(dateStr.split("T")[0].replace(/-/g, "/"));
  }
  return new Date(dateStr);
}

export function formatDate(dateStr) {
  if (!dateStr) return "___/___/______";
  const d = parseLocalDate(dateStr);
  if (!d || isNaN(d.getTime())) return "___/___/______";
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
}

export function formatDateInput(dateStr) {
  if (!dateStr) return "";
  // Đã đúng format rồi, trả về luôn
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;
  const d = parseLocalDate(dateStr);
  if (!d || isNaN(d.getTime())) return "";
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function calculateEndDate(startDate, duration) {
  if (!startDate || !duration) return "";
  if (duration === "Không xác định thời hạn") return null;

  const years = parseInt(duration);
  if (isNaN(years)) return "";

  const d = parseLocalDate(startDate);
  if (!d) return "";
  d.setFullYear(d.getFullYear() + years);

  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}